import React, { Component } from "react";
import { Link } from "react-router-dom";

class About extends Component {
  constructor(props) {
    super(props);
    this.state = {
      about: [
        {
          id: 1,
          icon: "bi bi-badge2",
          title: "Teachers Resource",
          text: "This picture book includes a comprehensive teachers resource pack to support classroom implementation and foster meaningful discussions among students.",
        },
        {
          id: 2,
          icon: "bi bi-support",
          title: "Parents Resource",
          text: "This picture book provides parents with resources and guidance to support their child's learning journey.",
        },
        {
          id: 3,
          icon: "bi bi-rocket2",
          title: "Individual Written Analysis (for assessment)",
          text: "This picture book includes an individual written analysis component to assess our understanding and engagement with the text and to evaluate our professional literacies.",
        },
      ],
    };
  }
  render() {
    return (
      <section className="about-section section-padding bg-grey" id="about">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <div className="about-img">
                <img
                  src="assets/images/banner/book.png"
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="section-heading">
                <span className="subheading">Group Assignment Option #2</span>
                <h3 className="heading-title">Picture Book</h3>
                <p>
                  This picture book has resources for teachers, parents, and
                  with individual written analysis as part of the assessment.
                  Click links below to see more.
                </p>
              </div>

              {this.state.about.map((data, i) => (
                <div className="about-text-block" key={i}>
                  <i className={data.icon}></i>
                  <h4>{data.title}</h4>
                  <p>{data.text} </p>
                </div>
              ))}

              <Link to="/more-about" className="btn btn-main-2">
                <i className="fa fa-check me-2"></i>More About This Picture Book
              </Link>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default About;
